export const calendarToolbar = {
  start: 'title',
  end: 'prev,next',
};

export const calendarToolbarMultipleView = {
  left: '',
  right: 'title prev,next',
};
